import { Route, Routes } from "react-router-dom";
// import './App.css';
import Home from './Home';
import PrivacyPolicy from './BrowDesigner/PrivacyPolicy';
import Terms from './BrowDesigner/Terms';
import Main from './BrowDesigner/Main';
import Redirect from './BrowDesigner/Redirect'
import Nightdrift from './Nightdrift/Main';
import NightdriftSupport from './Nightdrift/Support';
import NightdriftPrivacy from './Nightdrift/PrivacyPolicy';
import NightdriftTerms from './Nightdrift/Terms';
import { NIGHTDRIFT_APP_STORE_URL } from './Nightdrift/constants';

function App() {
  const url = "https://apps.apple.com/us/app/brow-designer/id6446804452"
  return (
    <Routes>
      <Route path='/' element={Home()} />
      <Route path='/browdesigner' element={Main()} />
      <Route path='/browdesigner/privacypolicy' element={PrivacyPolicy()} />
      <Route path='/browdesigner/terms' element={Terms()} />
      <Route path='/browdesigner/app'
        element={<Redirect url={url}/>}
      />
      <Route path='/nightdrift' element={Nightdrift()} />
      <Route path='/nightdrift/support' element={NightdriftSupport()} />
      <Route path='/nightdrift/privacypolicy' element={NightdriftPrivacy()} />
      <Route path='/nightdrift/terms' element={NightdriftTerms()} />
      <Route path='/nightdrift/app'
        element={<Redirect url={NIGHTDRIFT_APP_STORE_URL}/>}
      />
    </Routes>
  );
}

export default App;
